/* GRAPH_ */
export const GRAPH_LIST = "GRAPH_LIST";
export const GRAPH_LIST_SUCCESS = "GRAPH_LIST_SUCCESS";
export const GRAPH_LIST_FAILED = "GRAPH_LIST_FAILED";

